import { createContext, useContext, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState({}); // id -> {flower, qty}

  const setQty = (flower, qty) =>
    setItems((c) => {
      const n = { ...c };
      if (qty <= 0) delete n[flower.id];
      else n[flower.id] = { flower, qty };
      return n;
    });
  const add = (flower, mult) => setQty(flower, (items[flower.id]?.qty || 0) + mult);
  const clear = () => setItems({});
  const replace = (list) => {
    const map = {};
    list.forEach(({ flower, qty }) => (map[flower.id] = { flower, qty }));
    setItems(map);
  };

  const list = useMemo(() => Object.values(items), [items]);
  const total = list.reduce((s, i) => s + i.qty * (i.flower.price || 0), 0);
  const count = list.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, list, total, count, setQty, add, clear, replace }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
